<template>
  <component
    :is="elementTag"
    :class="classes"
    :disabled="elementTag === 'button' && disabled"
  >
    <span class="app-btn__content">
      <span v-if="icon" class="iconfont" :class="icon"></span>

      <slot></slot>
    </span>
    <div v-if="loading" class="app-btn__spinner">
      <CircleSpinner
        class="app-btn__spinner-icon"
        :animation-duration="2000"
        :size="16"
      />
    </div>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CircleSpinner from '@/components/ui/CircleSpinner.vue'

const props = withDefaults(
  defineProps<{
    /**
     * Reduce the size of the button
     */
    dense?: boolean
    /**
     * Make the button smaller than `dense`
     */
    small?: boolean
    /**
     * Make the button bigger
     */
    big?: boolean
    /**
     * Place the button in a disabled state
     */
    disabled?: boolean
    /**
     * Set the button to a disabled state
     */
    loading?: boolean
    /**
     * The iconfont icon to use
     */
    icon?: string
    /**
     * Use the outlined design variant
     */
    outlined?: boolean
    /**
     * Use the primary-alt design variant
     */
    primaryAlt?: boolean
    /**
     * Use the danger design variant
     */
    danger?: boolean
    /**
     * Anchor tag attribute that transform components into `<a href="" />`
     */
    href?: string
    /**
     * Element tag to use for the button. Defaults to `button`
     */
    tag?: string
  }>(),
  {
    tag: 'button',
  },
)

const classes = computed(() => {
  return {
    'app-btn': true,
    'app-btn--dense': props.dense,
    'app-btn--small': props.small,
    'app-btn--big': props.big,
    'app-btn--disabled': props.disabled,
    'app-btn--loading': props.loading,
    'app-btn--outlined': props.outlined,
    'app-btn--primary-alt': props.primaryAlt,
    'app-btn--danger': props.danger,
  }
})

const elementTag = computed(() => {
  const tag = (props.href && 'a') || props.tag || 'div'
  return tag
})
</script>
